import { CSSProperties } from 'react'
import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL

/** One cell, as Excel shows it. */
export interface RatesCell {
  /** The text, with the cell's number format applied. */
  t: string
  /** Index into `styles`. */
  s?: number
  /** Column and row span, on the top-left cell of a merge. */
  cs?: number
  rs?: number
  /** Inside another cell's merge, so not drawn. */
  x?: boolean
  /** A number: lines up on the right unless the sheet aligns it otherwise. */
  n?: boolean
}

export interface RatesSheet {
  name: string
  /** Column widths in pixels. */
  widths: number[]
  /** Rows kept in view at the top - the sheet's frozen rows. 0 when none are frozen. */
  headingRows: number
  rows: { height?: number; cells: RatesCell[] }[]
}

/** The schedules of rates spreadsheet, read on the API with its formatting. */
export interface SchedulesOfRates {
  fileName: string
  /** When the API fetched it from SharePoint. */
  retrievedAt: string
  sheets: RatesSheet[]
  /** Cell styles, as React style objects. */
  styles: CSSProperties[]
}

/** The current schedules of rates. `refresh` fetches it from SharePoint even if a recent copy is held. */
export const getSchedulesOfRates = async (refresh = false): Promise<SchedulesOfRates> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get(`https://${apiURL}/SchedulesOfRates`, {
    headers: { Authorization: 'Bearer ' + token },
    params: refresh ? { refresh: true } : undefined,
  })
  return response.data
}
